import store from "@/store";

export async function contactChecker(to, from, next) {
  if (to.matched.some(record => record.meta.needContact)) {
    if (store.getters['keycloak/isAdminGroup']) {
      if (to.matched.some(record => record.meta.adminNeedAsOrgAuth) && store.getters['keycloak/getFakeUser'])
        await next();
      else if (!to.matched.some(record => record.meta.adminNeedAsOrgAuth))
        await next();
      return;
    }
    if (store.getters['checkFilled/get_check_filled_status']) {
      await next();
    } else {
      try {
        const res = await store.dispatch('checkFilled/getContact', null, {root: true});
        if (res) {
          await next()
        } else {
          await next({
            name: 'contacts'
          });
          await store.dispatch('notifications/addNotification', {
            notificationStatus: 'warning',
            notificationMessage: 'Заполните контактные данные',
            timeout: 5000
          }, {root: true})
        }
      } catch (e) {
        console.error('contactChecker', e)
        await store.dispatch('notifications/addNotification', {
          notificationStatus: 'warning',
          notificationMessage: 'Заполните контактные данные ',
          timeout: 5000
        }, {root: true})
        await next({
          name: 'contacts'
        });
      }
    }
  }
}

export async function roleChecker(to, from, next) {
  if (to.matched && to.matched.some(record => record.meta.roles)) {
    let accept = false;
    const roles = to?.meta?.roles;
    for (const role of roles) {
      if (store.getters['keycloak/getRoles'] && store.getters['keycloak/getRoles'].includes(role))
        accept = true;
    }
    if (accept)
      await next();
    else
      await next({
        path: from.path
      })
  } else
    await next();
}

export async function adminChecker(to, from, next) {
  if (to.matched.some(record => record.meta.isAdmin)) {
    if (store.getters['keycloak/getRoles'] && store.getters['keycloak/isAdminGroup']) {
      console.log("Это админ")
      if (to.matched.some(record => record.meta.adminNeedAsOrgAuth)) {
        if (to.matched.some(record => record.meta.adminNeedAsOrgAuth) && store.getters['keycloak/getFakeUser'])
          await next();
        else if (to.matched.some(record => record.meta.adminNeedAsOrgAuth) && !store.getters['keycloak/getFakeUser'])
          await next({name: 'admin'});
        else
          await next();
      }
    } else {
      console.log("Это не админ")
      await next({name: 'contacts'});
    }
  }
}